import React, { useEffect, useState } from 'react';
import { IStepModuleProps } from 'src/models/modules';
import { StepValue, IReservationModel } from 'src/entities/reservation';
import { StepType } from 'src/services/getStepOrder';

interface IMockModuleComponentProps extends IStepModuleProps {
    name: StepType;
}

const MockModule: React.FC<IMockModuleComponentProps> = ({ data, name, onComplete }) => {
    const [value, setValue] = useState('');
    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValue(event.target.value);
    };

    useEffect(() => {
        const stepData: StepValue<object> | undefined =
            data[name as keyof Omit<IReservationModel, 'searchParams'>];
        setValue(stepData ? stepData.displayValue : '');
    }, []);

    return (
        <div style={{ width: '100%' }}>
            <p>{name} component</p>
            <input type="text" value={value} onChange={handleInputChange} />
            <button
                onClick={() =>
                    onComplete({
                        [name]: {
                            Id: 1,
                            Type: 1,
                            Name: 'Calendar 1',
                            displayValue: value,
                        },
                    })
                }
            >
                Next
            </button>
            <div>
                <p>
                    Lorem Ipsum egy egyszerû szövegrészlete, szövegutánzata a betûszedõ és
                    nyomdaiparnak. A Lorem Ipsum az 1500-as évek óta standard szövegrészletként
                    szolgált az iparban; mikor egy ismeretlen nyomdász összeállította a
                    betûkészletét és egy példa-könyvet vagy szöveget nyomott papírra, ezt használta.
                    Nem csak 5 évszázadot élt túl, de az elektronikus betûkészleteknél is
                    változatlanul megmaradt. Az 1960-as években népszerûsítették a Lorem Ipsum
                    részleteket magukbafoglaló Letraset lapokkal, és legutóbb softwarekkel mint
                    például az Aldus Pagemaker.
                </p>
            </div>
        </div>
    );
};

export default MockModule;
